import { createRouter, createWebHistory } from 'vue-router'
import ActivityForm from '@/components/ActivityForm.vue'
import ActivityList from '@/components/ActivityList.vue'
import Login from '@/components/Login.vue'
import Register from '@/components/Register.vue'
import AdminActivities from '@/components/AdminActivities.vue'
import AdminEntries from '@/components/AdminEntries.vue'
import AdminUsers from '@/components/AdminUsers.vue'
import Help from '@/components/Help.vue'
import Profile from '@/components/Profile.vue' 
import ForgotPassword from '@/components/ForgotPassword.vue'
import DataOverview from '@/components/DataOverview.vue'

const routes = [
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  { path: '/', name: 'Form', component: ActivityForm, meta: { requiresAuth: true } },
  { path: '/registros', name: 'Registros', component: ActivityList, meta: { requiresAuth: true } },
  { path: '/admin/atividades', component: AdminActivities, meta: { requiresAuth: true, adminOrManager: true } },
  { path: '/admin/registros', name: 'AdminRegistros', component: AdminEntries,
    meta: { requiresAuth: true, adminOrManager: true } },
  { path: '/admin/usuarios', name: 'AdminUsers', component: AdminUsers, meta: { requiresAuth: true, adminOnly: true } },
  { path: '/ajuda', name: 'Ajuda', component: Help },
  { path: '/perfil', name: 'Perfil', component: Profile, meta: {requiresAuth: true}},
  { path: '/senha', name: 'EsqueceuSenha', component: ForgotPassword},
  { path: '/admin/visao-geral', name: 'VisaoGeral', component: DataOverview, meta: { requiresAuth: true,  adminOrManager: true}}
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  if (to.meta?.requiresAuth && !token) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }
  if (to.meta?.adminOnly && !user?.admin) {
    return next('/') 
  }
  if (to.meta.adminOrManager) {
    if (user.admin || user.manager) {
      return next()
    }
    return next('/')
  }
  next()
})

export default router
